import { render, staticRenderFns } from "./PodcastItem.vue?vue&type=template&id=2f52b11f&"
import script from "./PodcastItem.vue?vue&type=script&lang=js&"
export * from "./PodcastItem.vue?vue&type=script&lang=js&"
import style0 from "./PodcastItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports